<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">อัพโหลดไฟล์เรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ {{ header_list.order_code }}</b></div>
            <div v-if="header_list.order_status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #86bc3a">คำสั่งซื้อใหม่</b></div>
            <div v-else-if="header_list.order_status === 1" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #fdac39">ดำเนินการจัดสินค้า</b></div>
            <div v-else-if="header_list.order_status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #eb5c5d">ยกเลิก</b></div>
            <div v-else-if="header_list.order_status === 3" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">เสร็จสิ้น</b></div>
          </div>
          <div v-if="header_list.order_status === 3 && header_list.delivery_type === 1" class="grid_sub_half">
            <div class="padding_header" style="color: black"><b>หมายเลขแทร็กกิ้ง : {{ header_list.tracking_number }}</b></div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกค้า</b></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อลูกค้า : </div>
              <div class="ml-1 mr-3">{{ header_list.customer_name }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ที่อยู่จัดส่ง : </div>
              <div v-if="header_list.delivery_type !== 0" class="ml-1 mr-3">{{ header_list.address }}</div>
              <div v-else class="ml-1 mr-3">รับที่ร้านฟาร์มาแคร์ พลัส (สำนักงานใหญ่)</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div v-if="header_list.telephone !== null" class="ml-1 mr-3">{{ header_list.telephone }}</div>
              <div v-else class="ml-1 mr-3">-</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>หลักฐานการชำระเงิน</b></div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ชำระผ่าน : </div>
                  <div class="ml-1 mr-3">โอนเงิน</div>
                  <div v-if="header_list.payment_type === 1" class="ml-1 mr-3">โอนเงิน</div>
                  <div v-else-if="header_list.payment_type === 2" class="ml-1 mr-3">ติดเครดิต</div>
                  <div v-else-if="header_list.payment_type === 3" class="ml-1 mr-3">รับสินค้าหน้าร้าน</div>
                </div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดชำระ : </div>
                  <div v-if="header_list.delivery_type == 1" class="ml-1 mr-3">{{ format_price(parseFloat(header_list.total)) }} บาท</div>
                  <div v-else class="ml-1 mr-3">{{ format_price(parseFloat(header_list.total)) }} บาท</div>
                </div>
                <div v-if="header_list.order_status === 3 && header_list.slips !== null" class="d-flex mt-2" style="color: #86bc3a;">
                  <div class="ml-1 mr-3">ผู้อัพโหลด : </div>
                  <div class="ml-1 mr-3">{{ header_list.user_create_name }} {{ header_list.created_date }}</div>
                </div>
                <div v-else-if="header_list.order_status === 1 && header_list.slips !== null" class="d-flex mt-2" style="color: #86bc3a;">
                  <div class="ml-1 mr-3">ผู้อัพโหลด : </div>
                  <div class="ml-1 mr-3">{{ header_list.user_create_name }} {{ header_list.created_date }}</div>
                </div>
                <div v-if="header_list.order_status === 2" class="d-flex mt-2" style="color: red;">
                  <div class="ml-1 mr-3">ยกเลิก : </div>
                  <div class="ml-1 mr-3">{{ header_list.cancel_note }}</div>
                </div>
                <div v-if="header_list.order_status === 2" class="d-flex mt-2" style="color: red;">
                  <div class="ml-1 mr-3">ผู้ยกเลิก : </div>
                  <div class="ml-1 mr-3">{{ header_list.user_create_name }} {{ header_list.cancel_date }}</div>
                </div>
                <div v-if="header_list.order_status === 0" class="mt-2 display_pc">
                  <v-btn elevation="5" @click="image_addon = true" class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานการโอนเงิน</v-btn>
                  <v-btn elevation="5" @click="cancel_order = true" class="mobile_btn pa-6 ma-1 grad-danger-bg white--text rounded-pill">ยกเลิกคำสั่งซื้อ</v-btn>
                </div>
              </div>
              <div v-if="header_list.order_status !== 2" class="mx-auto">
                <v-img v-if="header_list.slips !== null" class="mx-auto rounded cursor_img" height="160" width="160" max-width="160" :lazy-src="picture_holder" :src="header_list.slips"></v-img>
                <v-img v-else class="mx-auto rounded cursor_img" height="160" width="160" max-width="160" :lazy-src="picture_holder" :src="picture_holder"></v-img>
              </div>
              <div v-if="header_list.order_status === 0" class="mt-2 display_mobile">
                <v-btn elevation="5" @click="image_addon = true" class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานการโอนเงิน</v-btn>
                <v-btn elevation="5" @click="cancel_order = true" class="mobile_btn pa-6 ma-1 grad-danger-bg white--text rounded-pill">ยกเลิกคำสั่งซื้อ</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider/>
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage" hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="border_table">
                      <div class="mx-auto pa-3">
                        <v-img class="rounded mx-auto" height="120" width="120" max-width="120" v-if="dataDetail.item.product_picture !== null" :lazy-src="picture_product" :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="rounded mx-auto" height="120" width="120" max-width="120" v-else :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div>{{ dataDetail.item.product_name }}</div>
                    </td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.cost) }}</td>
                    <td class="border_table text-center">{{ format_number(dataDetail.item.quantity) }} {{ dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.total) }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ส่วนลดท้ายบิล</b></td>
                    <td class="border_table text-center"><b>{{ format_price(header_list.discount) }}</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td v-if="header_list.delivery_type == 1" class="border_table text-center"><b>{{ format_price(header_list.delivery_price) }}</b></td>
                    <td v-else class="border_table text-center"><b>0.00</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <td v-if="header_list.delivery_type == 1" class="border_table text-center"><b>{{ format_price(parseFloat(header_list.total)) }}</b></td>
                    <td v-else class="border_table text-center"><b>{{ format_price(parseFloat(header_list.total)) }}</b></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </div>
        <div v-if="header_list.order_status === 1" class="text-center pa-5 mb-3">
          <v-btn large elevation="5" style="font-size: 18px" @click="edit_product" class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
            <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
          </v-btn>
          <v-btn large elevation="5" style="font-size: 18px" @click="print_product" class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
            <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
          </v-btn>
          <v-btn large elevation="5" @click="print_tax_invoice" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
            <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
          </v-btn>
        </div>
        <div v-if="header_list.order_status === 3" class="text-center pa-5 mb-3">
          <v-btn large elevation="5" style="font-size: 18px" @click="print_product" class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
            <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
          </v-btn>
          <v-btn large elevation="5" @click="print_tax_invoice" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
            <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
          </v-btn>
        </div>
      </div>
      <v-dialog v-model="image_addon" max-width="520">
        <v-card>
          <v-form ref="image" @submit.prevent="upload_addon">
            <div class="d-flex justify-space-between">
              <v-card-title>
                อัพโหลดหลักฐานการโอนเงินเพิ่มเติม
              </v-card-title>
              <v-btn icon class="ma-4" @click="image_addon = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="ml-4">
                  <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_holder" :src="picture_holder" class="preview mx-auto"></v-img>
                  <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                </div>
                <v-file-input prepend-icon="mdi-image" color="#86bc3a" accept="image/*" label="อัพโหลด" :rules="[v => !!v || 'กรุณาอัพโหลดไฟล์']" v-model="send_data.addon_file" @change="onFileChange"></v-file-input>
                <div>การอัพโหลดหลักฐานเพิ่มเติมจาก Admin จะทำการยืนยันหลักฐาน อัตโนมัติ</div>
                <div class="mt-6">
                  <v-btn x-large v-if="imagePreviewURL == null" class="rounded-pill white--text grad-grey-bg btn_size" disabled>อัพโหลด</v-btn>
                  <v-btn type="submit" x-large v-if="imagePreviewURL !== null" class="rounded-pill white--text grad-success-bg btn_size">อัพโหลด</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cancel_order" max-width="700">
        <v-card>
          <v-form ref="cancel" @submit.prevent="save_cancel">
            <div class="d-flex justify-space-between">
              <v-card-title>
                ยกเลิกคำสั่งซื้อ
              </v-card-title>
              <v-btn icon class="ma-4" @click="cancel_order = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="mb-5" style="font-size: 20px">คุณต้องการยกเลิกคำสั่งซื้อของลูกค้าเพราะเหตุใด ?</div>
                <v-text-field color="#86bc3a" label="กรุณากรอกเหตุผลการยกเลิกออเดอร์" v-model="send_data.cancel_note" :rules="[v => !!v || 'กรุณากรอกเหตุผลการยกเลิกออเดอร์']" hide-details="auto" outlined></v-text-field>
              </div>
              <div class="text-center mt-4">
                <v-btn x-large type="submit" class="rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/image-not-found.png";
import picture_product from "@/assets/pill.png";
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_other_detail",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      picture_product: picture_product,
      overlay: false,
      alert_success: false,
      perPage: -1,
      status: 1,
      order_number: '',
      image_modal: false,
      image_addon: false,
      cancel_order: false,
      imagePreviewURL: null,
      send_data: {
        addon_file: '',
        cancel_note: '',
      },
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      header_list: [],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.send_data.addon_file = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.send_data.addon_file = null
          }
        }
      }else {
        this.imagePreviewURL = null
        this.send_data.addon_file = null
      }
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/neworders/detail', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.object.order
          this.data_list = res.data.object.orderlists
        }
      })
    },
    upload_addon() {
      if (this.$refs.image.validate()) {
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.send_data.addon_file.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.send_data.addon_file = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('slip', this.send_data.addon_file);
          formData.append('order_id', this.$route.params.id);
          this.overlay = true
          HTTP.post('/neworders/uploadslip', formData, config)
              .then((res) => {
                if (res.data.success === true) {
                  this.image_addon = false
                  this.overlay = false
                  this.send_data.addon_file = null
                  this.alert_success = true
                  setTimeout(() => this.alert_success = false, 2000)
                  this.get_data()
                }
              })
        }
      }
    },
    save_cancel() {
      if (this.$refs.cancel.validate()) {
        Swal.fire({
          title: 'ต้องการยกเลิกคำสั่งซื้อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.overlay = true
            HTTP.post('/neworders/cancel', {
              order_id: this.$route.params.id,
              cancel_note: this.send_data.cancel_note
            }).then((res) => {
              if (res.data.success === true) {
                this.send_data.cancel_note = ''
                this.overlay = false
                this.cancel_order = false
                this.get_data()
              }
            })
          }
          else {
            this.send_data.cancel_note = ''
          }
        })
      }
    },
    edit_product() {
      this.$router.push('/sell/orderothereditlots/' + this.header_list.id)
    },
    print_product() {
      if (this.header_list.payment_type !== 3) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpayadmin/' + this.header_list.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipadmin/' + this.header_list.order_code, '_blank')
      } else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpayadmin/' + this.header_list.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipadmin/' + this.header_list.order_code, '_blank')
      }
      if (this.header_list.delivery_type != 0) {
         window.open('https://www.pharmacare-plus.com/envelopeadmin/' + this.header_list.order_code, '_blank')
      }
    },
    print_tax_invoice() {
      window.open('https://www.pharmacare-plus.com/taxinvoiceadmin/' + this.header_list.order_code, '_blank')
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}
.btn_size {
  width: 100%;
}
.rounded_card {
  border-radius: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_img {
  display: grid;
  grid-template-columns:70% 30%;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.display_pc {
  display: block;
}
.display_mobile {
  display: none;
}
.mobile_grid {
  width: 25% !important
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_grid {
    width: 32% !important
  }
}
@media only screen and (max-width: 500px) {
  .grid_mx {
    margin: auto;
  }
  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: block;
  }
  .mobile_btn {
    width: 100%;
    margin-left: 0 !important;
  }
  .mobile_grid {
    width: 100% !important
  }
}
</style>
